import { render, staticRenderFns } from "./settingsDiscountDialog.vue?vue&type=template&id=7f0b27ae&scoped=true"
import script from "./settingsDiscountDialog.vue?vue&type=script&lang=js"
export * from "./settingsDiscountDialog.vue?vue&type=script&lang=js"
import style0 from "./settingsDiscountDialog.vue?vue&type=style&index=0&id=7f0b27ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0b27ae",
  null
  
)

export default component.exports